<!--
 * @Overview:   FoundsRecordItem
 * @Author:     Zi_Jun
 * @Email:      zijun2030@163.com
 * @Date:       2020/7/15 15:38
 * @Mark:
 -->

<template>
  <div class="founds-record-item">
    <div class="top-wrap">
      <p class="part-1" :class="changeTypeColor">
        {{ changeTypeText }}
      </p>
      <p class="part-2 num-text">{{ (data.is_all == 1 && data.funds_type == 2) ? data.amount : mixinAmountDisplay(data.amount) }}</p>
      <p class="part-3 num-text num-unit">{{ data.remittance_currency }}</p>
      <p class="part-4" :class="statusColor">{{ statusText }}</p>
    </div>
    <div class="bottom-wrap">
      <div class="bottom-wrap-left">
        <p class="time-text">{{ data.created_at }}</p>
        <p class="fail-text" v-if="data.order_status === 4">
          {{ $t("myComponent.domText") }}
        </p>
      </div>
<!--      <p>{{ accountTypeText }}</p>-->
    </div>
  </div>
</template>

<script>
import amountDisplay from "@/mixins/amountDisplay";

export default {
  name: "FundsRecordItem",
  mixins: [
    amountDisplay
  ],
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },

  computed: {
    changeTypeText() {
      switch (this.data.funds_change_type) {
        case 1:
          return this.$t("myComponent.typeText[0]");
        case 2:
          return this.$t("myComponent.typeText[1]");
        case 5:
          return this.$t("myComponent.typeText[2]");
        default:
          return "";
      }
    },
    changeTypeColor() {
      switch (this.data.funds_change_type) {
        case 1:
          return "red-color";
        case 2:
          return "green-color";
        case 5:
          return "green-color";
        default:
          return "";
      }
    },
    statusText() {
      switch (this.data.order_status) {
        case 0:
          return this.$t("myComponent.statusText[0]");
        case 1:
          return this.$t("myComponent.statusText[1]");
        case 2:
          return this.$t("myComponent.statusText[2]");
        case 3:
          return this.$t("myComponent.statusText[3]");
        case 4:
          return this.$t("myComponent.statusText[4]");
		case 5:
		  return this.$t("myComponent.statusText[5]");
        default:
          return "";
      }
    },
    statusColor() {
      switch (this.data.order_status) {
        case 0:
          return "wait-color";
        case 1:
        case 3:
          return "success-color";
        case 2:
          return "fail-color";
        case 4:
          return "back-color";
        default:
          return "";
      }
    },
    accountTypeText() {
      switch (this.data.funds_account_type) {
        case 1:
          return this.$t("myComponent.accountTypeText[0]");
        case 2:
          return this.$t("myComponent.accountTypeText[1]");
        default:
          return "";
      }
    }
  }
};
</script>

<style scoped lang="less">
.founds-record-item {
  height: 120px;
  padding: 10px 20px 10px 40px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .top-wrap {
    height: 44px;
    display: flex;
    align-items: center;
    .part-1 {
      font-size: 32px;
      line-height: 44px;
      font-weight: bold;
    }
    .red-color {
      color: #02aa39;
    }
    .green-color {
      color: #fc5252;
    }
    .part-2 {
      margin-left: 78px;
    }
    .num-text {
      font-size: 32px;
      line-height: 44px;
      font-weight: bold;
      color: #444;
    }
    .num-unit {
      padding-left: 10px;
      margin-right: auto;
    }
    .part-4 {
      box-sizing: border-box;
      margin-left: auto;
      padding: 6px 0;
      font-size: 20px;
      line-height: 28px;
      /*color: #ff9275;*/
      border-radius: 8px;
      background: #fff;
      &.wait-color {
        color: #f69500;
      }
      &.success-color {
        color: #1c0955;
      }
      &.fail-color {
        color: #ff9275;
      }
      &.back-color {
        color: #02aa39;
      }
    }
  }
  .bottom-wrap {
    height: 28px;
    display: flex;
    justify-content: space-between;
    p {
      font-size: 20px;
      line-height: 28px;
      color: #888;
    }
    .bottom-wrap-left {
      display: flex;
    }
    .time-text {
      max-width: 280px;
    }
    .fail-text {
      margin-left: 96px;
      color: #f69500;
    }
  }
}
</style>
